import { Fragment } from "react";
import { Alert, AlertDescription } from "@opencloud/ui";
import { agentBrand } from "../brand.js";
import type { AgentAppView, SessionView } from "../types.js";

/**
 * The apps someone can build in when their own plan leaves the hosted Agent
 * out: apps they were invited to administer, on their owners' plans.
 */
export function sharedAgentApps(
  session: Pick<SessionView, "userId" | "hostedAgent"> | null | undefined,
  apps: readonly AgentAppView[],
): AgentAppView[] {
  const access = session?.hostedAgent;
  if (!session || !access?.sharedAppsOnly) return [];
  const named = access.sharedAppIds ? new Set(access.sharedAppIds) : null;
  return apps.filter((app) => app.ownerUserId !== session.userId && (!named || named.has(app.id)));
}

/** Above a chat of their own, points that person to those apps' chats. */
export function SharedAppsNotice({ apps, onSelectApp }: {
  apps: readonly AgentAppView[];
  onSelectApp: (app: AgentAppView) => void;
}) {
  if (!apps.length) return null;
  const brand = agentBrand();
  return <Alert><AlertDescription>
    {`Your plan doesn't include ${brand.productName} ${brand.agentName} for chats of your own. To change an app someone shared with you, open its chat, which runs on the owner's plan: `}
    {apps.map((app, index) => <Fragment key={app.id}>
      {index ? ", " : null}
      <a href={`/${encodeURIComponent(app.slug || app.id)}`} onClick={(event) => {
        event.preventDefault();
        onSelectApp(app);
      }}>{app.name ?? "Untitled app"}</a>
    </Fragment>)}
    .
  </AlertDescription></Alert>;
}
